<template>
  <b-modal
    id="modal-business-preferences"
    hide-footer
    hide-header
    hide-header-close
    centered
    @hidden="resetCondition"
  >
    <div class="p-2">
      <div class="mb-2">
        <h2 class="text-center font-weight-bold text-black mb-2">
          Preferensi Bisnis & Beriklan
        </h2>
        <p class="text-center text-secondary">
          Mulai dengan memilih bisnis dan platform iklan yang paling sesuai
          dengan kebutuhan Anda
        </p>
      </div>

      <b-form @submit.prevent="onSubmit">
        <ValidationObserver v-slot="{ invalid }">
          <!-- Platform Selection -->
          <b-form-group>
            <template #label>
              <div class="text-md text-black d-flex align-items-center">
                Platform Akun Iklan
                <span class="text-danger">*</span>
              </div>
            </template>
            <ValidationProvider
              v-slot="{ errors }"
              name="Platform Akun Iklan"
              rules="required"
            >
              <div class="platform-options">
                <div
                  v-for="option in platformOptions"
                  :key="option.value"
                  class="platform-option-card"
                  :class="{ selected: form.platforms.includes(option.value) }"
                  @click="togglePlatform(option.value)"
                >
                  <div class="platform-content">
                    <div class="platform-icon">
                      <img
                        v-if="option.value === 'meta'"
                        src="https://storage.googleapis.com/komerce/komads-meta/meta.svg
"
                        alt="Meta"
                        width="24"
                        height="24"
                      >
                      <img
                        v-else-if="option.value === 'google'"
                        src="https://storage.googleapis.com/komerce/komads-meta/google.svg"
                        alt="Google"
                        width="24"
                        height="24"
                      >
                      <img
                        v-else-if="option.value === 'tiktok'"
                        src="https://storage.googleapis.com/komerce/komads-meta/tiktok.svg"
                        alt="TikTok"
                        width="24"
                        height="24"
                      >
                    </div>
                    <span class="platform-text">{{ option.text }}</span>
                    <div class="platform-check">
                      <b-form-checkbox
                        v-model="form.platforms"
                        :value="option.value"
                        class="custom-checkbox"
                        @click.stop
                      />
                    </div>
                  </div>
                </div>
              </div>
              <small
                v-if="errors.length > 0"
                class="text-danger"
              >{{
                errors[0]
              }}</small>
            </ValidationProvider>
          </b-form-group>

          <!-- Product/Type Type -->
          <b-form-group>
            <template #label>
              <div class="text-md text-black d-flex align-items-center">
                Jenis Produk/Layanan
                <span class="text-danger">*</span>
              </div>
            </template>
            <ValidationProvider
              v-slot="{ errors }"
              name="Jenis Produk/Layanan"
              rules="required"
            >
              <b-form-select
                v-model="form.product_type"
                :options="productTypeOptions"
                :state="errors.length > 0 ? false : null"
                @change="onProductTypeChange"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </b-form-group>

          <!-- Other Product/Type Input (shown when "Lainnya" is selected) -->
          <b-form-group v-if="form.product_type === 'lainnya'">
            <ValidationProvider
              v-slot="{ errors }"
              name="Produk/Layanan"
              rules="required|min:3|max:100"
            >
              <b-form-input
                v-model="form.other_product"
                placeholder="Jelaskan jenis produk/layanan Anda"
                maxlength="100"
                :state="errors.length > 0 ? false : null"
              />
              <div class="d-flex justify-content-between align-items-center">
                <small
                  v-if="errors.length > 0"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
                <small class="text-secondary">
                  {{ form.other_product.length }}/100 karakter
                </small>
              </div>
            </ValidationProvider>
          </b-form-group>

          <!-- Landing Page Link -->
          <b-form-group class="mb-2">
            <template #label>
              <div class="text-md text-black">
                Link Landingpage Produk/Layanan
              </div>
            </template>
            <b-form-input
              id="link-lp"
              v-model="form.product_landing_page_link"
              placeholder="Tautan langsung ke halaman toko atau landing page produk Kamu"
            />
          </b-form-group>

          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="flex-grow-1 mr-2"
              @click="$bvModal.hide('modal-business-preferences')"
            >
              Batal
            </b-button>
            <b-button
              :variant="!isFormValid ? 'secondary' : 'primary'"
              class="flex-grow-1"
              type="submit"
              :disabled="isSubmitting || invalid || !isFormValid"
            >
              <b-spinner
                v-if="isSubmitting"
                small
              />
              <span v-else>Kirim</span>
            </b-button>
          </div>
        </ValidationObserver>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      form: {
        platforms: [],
        product_type: '',
        other_product: '',
        product_landing_page_link: '',
      },
      isSubmitting: false,
      platformOptions: [
        { text: 'Meta Whitelist', value: 'meta' },
        { text: 'Google Whitelist', value: 'google' },
        { text: 'TikTok Whitelist', value: 'tiktok' },
      ],
      productTypeOptions: [
        { text: 'Pilih jenis produk/layanan', value: '', disabled: true },
        { text: 'Makanan & Minuman', value: 'makanan_minuman' },
        { text: 'Fashion & Aksesoris', value: 'fashion_aksesoris' },
        { text: 'Kesehatan & Kecantikan', value: 'kesehatan_kecantikan' },
        { text: 'Elektronik & Gadget', value: 'elektronik_gadget' },
        { text: 'Peralatan Rumah Tangga', value: 'peralatan_rumah_tangga' },
        { text: 'Mainan & Hobi', value: 'mainan_hobi' },
        { text: 'Otomotif', value: 'otomotif' },
        { text: 'Perlengkapan Bayi & Anak', value: 'perlengkapan_bayi_anak' },
        { text: 'Alat Tulis & Kantor', value: 'alat_tulis_kantor' },
        { text: 'Buku & Media', value: 'buku_media' },
        {
          text: 'Produk Digital (eBook, Template, dll)',
          value: 'produk_digital',
        },
        { text: 'Software / Aplikasi', value: 'software_aplikasi' },
        { text: 'Jasa Desain', value: 'jasa_desain' },
        {
          text: 'Jasa Pembuatan Website / Aplikasi',
          value: 'jasa_web_aplikasi',
        },
        { text: 'Jasa Fotografi / Videografi', value: 'jasa_foto_video' },
        {
          text: 'Konsultasi Profesional (hukum, bisnis, psikologi, dll)',
          value: 'konsultasi_profesional',
        },
        { text: 'Pelatihan / Kursus', value: 'pelatihan_kursus' },
        { text: 'Layanan Berlangganan', value: 'layanan_berlangganan' },
        { text: 'Event / Tiket', value: 'event_tiket' },
        {
          text: 'Donasi / Penggalangan Dana',
          value: 'donasi_penggalangan_dana',
        },
        { text: 'Lainnya', value: 'lainnya' },
      ],
    }
  },
  computed: {
    /**
     * Check if form is valid based on required fields
     */
    isFormValid() {
      const hasRequiredFields = this.form.platforms.length > 0 && this.form.product_type

      // If "Lainnya" is selected, also check if other_product is filled
      if (this.form.product_type === 'lainnya') {
        return (
          hasRequiredFields
          && this.form.other_product.trim().length >= 3
        )
      }

      return hasRequiredFields
    },
  },
  methods: {
    /**
     * Toggle platform selection
     */
    togglePlatform(value) {
      const platforms = [...this.form.platforms]
      const index = platforms.indexOf(value)

      if (index > -1) {
        platforms.splice(index, 1)
      } else {
        platforms.push(value)
      }

      this.$set(this.form, 'platforms', platforms)
    },

    /**
     * Handle product Type change
     */
    onProductTypeChange() {
      if (this.form.product_type !== 'lainnya') {
        this.form.other_product = ''
      }
    },

    /**
     * Reset form condition when modal is closed
     */
    resetCondition() {
      this.form = {
        platforms: [],
        product_type: '',
        other_product: '',
        product_landing_page_link: '',
      }
      this.isSubmitting = false
    },

    async onSubmit() {
      this.isSubmitting = true

      // Prepare form data for submission
      const submitData = {
        product_landing_page_link: this.form.product_landing_page_link,
        platform_name: this.form.platforms.join(','),
        product_type:
          this.form.product_type === 'lainnya'
            ? this.form.other_product
            : this.form.product_type,
      }

      await newAxiosIns
        .post('/komads/api/v1/whitelist_accounts/business_preferences/store', submitData)
        .then(() => {
          this.resetCondition()
          this.$bvModal.hide('modal-business-preferences')
          this.$toast_success({
            message: 'Pendaftaran akun berhasil',
          })
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        })
        .catch(error => {
          // --- 1️⃣ Extract error info safely ---
          const errorKey = error?.response?.data?.meta?.errors?.[0]?.key || 'unknown_error'
          const errorMessage = error?.response?.data?.meta?.message || ''
          const formattedErrorMessage = errorMessage.replace(/\s+/g, '_').toLowerCase()

          // --- 2️⃣ Define centralized map ---
          const ERROR_MESSAGE_MAP = {
            business_preference_already_submitted: 'Terjadi kesalahan pengisian data. Silahkan refresh halaman untuk memperbarui data.',
            whitelist_request_exist: 'Terjadi kesalahan pada akun whitelisted. Silahkan login kembali untuk memperbarui data.',
          }

          // --- 3️⃣ Cari apakah formatted message mengandung salah satu key ---
          const matchedKeyFromMessage = Object.keys(ERROR_MESSAGE_MAP).find(key => formattedErrorMessage.includes(key))

          // --- 4️⃣ Tentukan key akhir yang dipakai ---
          const matchedKey = matchedKeyFromMessage || errorKey

          // --- 5️⃣ Ambil pesan yang sesuai atau fallback ---
          const userFriendlyMessage = ERROR_MESSAGE_MAP[matchedKey]
    || 'Terjadi kesalahan pada sistem. Coba lagi beberapa saat atau hubungi CS.'

          // --- 6️⃣ Tampilkan toast ---
          this.$toast_error({ message: userFriendlyMessage })
        })
        .finally(() => {
          this.isSubmitting = false
        })

      const postMessage = { type: 'GET_STATUS_ONBOARDING' }
      const iframe = document.querySelector('#whitelisted-komads')
      if (iframe) {
        iframe.contentWindow.postMessage(postMessage, '*')
      }
    },
  },
}
</script>

<style scoped>
.bg-light-gray {
  background-color: #f5f5f5;
  color: #333;
}

.platform-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.platform-option-card {
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 4px 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: white;
}

.platform-option-card:hover {
  border-color: #f95031;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
}

.platform-option-card.selected {
  border-color: #f95031;
  background-color: #f8fff9;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.1);
}

.platform-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.platform-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.platform-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.platform-text {
  flex: 1;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.platform-check {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  pointer-events: none;
}

.platform-check .custom-checkbox {
  pointer-events: none;
}

.platform-option-card.selected::before {
  background-color: #f95031;
  border-color: #f95031;
}
</style>
